module.exports = __webpack_public_path__ + "static/img/ys.71db113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Virus/Lentivirus/ys.png
// module id = MnAb
// module chunks = 1